"use strict";
function u(n, t) {
  return function() {
    return n.apply(t, arguments);
  };
}
export {
  u as default
};
//# sourceMappingURL=index.es145.js.map
